import { render } from "./PrivateCate.vue?vue&type=template&id=732435a5"
import script from "./PrivateCate.vue?vue&type=script&lang=js"
export * from "./PrivateCate.vue?vue&type=script&lang=js"

import "./PrivateCate.vue?vue&type=style&index=0&id=732435a5&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__